export default __webpack_public_path__ + "static/media/left-1.0dd53e08.png";